import process from 'process';

const config = {
    API: process.env.REACT_APP_API ?? '',
    CRYPTO_LIB_API: process.env.REACT_APP_CRYPTO_LIB_API ?? '',
    WORKFLOW_API: process.env.REACT_APP_WORKFLOW_API ?? '',
    PRICE_DEC_API: process.env.REACT_APP_PRICE_DEC_API ?? '',
};

export default config;
